<div class="jumbotron jumbotron-fluid">
  <div class="jumbotron_content">
    <div class="banner">
      <p>Explore all our services</p>
      <span>
        From switching energy or broadband suppliers, to help with insurance and debt management Don't Waste Money
        are here to help you find top money-saving opportunities.
      </span>
      <div class="bannerBtns gap-3">
        <a href="https://quote.dontwastemoney.co.uk/" target="_blank" rel="noopener noreferrer">
          <button mat-flat-button color="primary" class="px-4">Switch Now</button>
        </a>
      </div>
    </div>

    <img class="bannerImg img-fluid" src="assets/images/services_banner.svg" alt="banner" />
  </div>
</div>
